import {
    createLoadingSpinner,
    LOADING_SPINNER_SIZE_MEDIUM,
    LoadingSpinner,
} from '@vfde-brix/ws10/loading-spinner';
import { selectLoading } from 'Container/App/selectors';
import { startAppListening } from 'Container/App/listener';

/**
 * Mount loading spinner
 */
export default function mountLoadingSpinner (id: string): LoadingSpinner | null {
    const container = document.getElementById(id);

    if (!container) {
        return null;
    }

    const loadingSpinner = createLoadingSpinner(container, {
        business: {},
        optSize: LOADING_SPINNER_SIZE_MEDIUM,
    });

    loadingSpinner.toggle(true);

    startAppListening({
        predicate: (action, currentState, previousState) =>
            selectLoading(currentState) !== selectLoading(previousState),
        effect: (action, listenerApi) => {
            listenerApi.cancelActiveListeners();

            const isLoading = selectLoading(listenerApi.getState());

            loadingSpinner.toggle(isLoading);
        },
    });

    return loadingSpinner;
}
